import React, { FC, useEffect, useState } from "react";
import { graphic } from "echarts";
import styles from "./ChartStatusSummary.module.scss";

type DataItem = {
  xAxisData: string;
  seriesData: number;
  color: graphic.LinearGradient;
};

type Props = {
  xAxisData: string[];
  seriesData: number[];
  colors: graphic.LinearGradient[];
};

export const ChartStatusSummary: FC<Props> = ({
  xAxisData,
  seriesData,
  colors,
}) => {
  const allData: DataItem[] = xAxisData.map((data, index) => ({
    xAxisData: data,
    seriesData: seriesData[index],
    color: colors[index % colors.length],
  }));

  return (
    <section className={styles.chartsSummary}>
      <ul className={styles.wrapperItems}>
        {allData.map((item, index) => (
          <li key={index} className={styles.dataItem}>
            <div className={styles.group}>
              <div className={styles.firstGroup}>
                <div
                  className={styles.circle}
                  style={{
                    background: `linear-gradient(${item.color.colorStops[0].color}, ${item.color.colorStops[1].color})`,
                  }}
                />
                <h6 className={styles.name}>{item.xAxisData}</h6>
              </div>
              <div
                style={{
                  background: `linear-gradient(${item.color.colorStops[0].color}, ${item.color.colorStops[1].color})`,
                }}
                className={styles.seriesData}
              >
                <p className={styles.count}>{item.seriesData}</p>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};
